<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <!-- Sync Date Info Section -->
  <div *ngIf="syncDate" class="mb-4 px-4 py-2 rounded-lg border bg-gray-50 border-gray-200">
    <div class="flex items-center space-x-2">
      <mat-icon class="text-sm text-blue-600">info</mat-icon>
      <span class="text-sm font-poppins text-gray-700">
        Data refreshed on <span class="font-semibold">{{ formattedSyncDate }}</span
        >.
      </span>
    </div>
  </div>

  <div class="flex items-center mb-5">
    <div class="w-5 h-5 rounded-full mr-4 relative" [ngClass]="risk.indicatorClass">
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <h2 class="text-xl font-poppins font-semibold text-[#E53935] mb-0">Blacklist Exposure</h2>
  </div>

  <div class="space-y-4">
    <div
      class="flex flex-wrap gap-3 items-center justify-between pb-3 border-b border-dashed border-gray-200"
    >
      <span class="text-sm font-poppins font-semibold text-[#4B4B4B]">Risk Classification</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="risk.badgeClass"
      >
        {{ risk.label }}
      </span>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div class="rounded-lg p-4 bg-red-50">
        <div class="text-sm text-red-600 font-poppins font-medium">Confirmed Matches</div>
        <div class="text-2xl font-poppins font-semibold text-red-800">
          {{ sortedMatches.length }}
        </div>
      </div>
      <div class="rounded-lg p-4 bg-orange-50">
        <div class="text-sm text-orange-600 font-poppins font-medium">Distinct Sources</div>
        <div class="text-2xl font-poppins font-semibold text-orange-800">{{ sourcesScanned }}</div>
      </div>
    </div>

    <p class="text-[#4B4B4B] text-sm font-poppins leading-relaxed">{{ risk.description }}</p>

    <div
      *ngIf="sortedMatches.length > 0"
      class="rounded-lg border border-gray-200 bg-white overflow-hidden"
    >
      <div class="px-4 py-2 text-sm font-poppins font-semibold bg-red-50 text-red-700">
        Top Matches (sorted by similarity)
      </div>
      <ul class="divide-y divide-gray-200">
        <li
          *ngFor="let match of topMatches; let i = index"
          class="px-4 py-3 bg-white text-gray-700"
        >
          <div class="flex items-center justify-between">
            <div>
              <div class="font-poppins font-semibold text-base">{{ match.name }}</div>
              <div class="text-xs font-poppins opacity-80">{{ match.address }}</div>
            </div>
            <div class="text-right">
              <div class="text-sm font-poppins font-medium">
                {{ formatConfidenceLabel(match.matchConfidence) }}
              </div>
              <div class="text-xs font-poppins opacity-70">
                Similarity: {{ match.similarityScore.toFixed(2) }}
              </div>
            </div>
          </div>
          <div class="mt-2 grid grid-cols-2 gap-2 text-xs font-poppins">
            <span class="font-medium text-[#4B4B4B]">Debarred:</span>
            <span>{{ match.debarringDate || 'N/A' }}</span>
            <span class="font-medium text-[#4B4B4B]">Source:</span>
            <span>{{ match.source || match.portal || 'N/A' }}</span>
          </div>
          <a
            *ngIf="match.links"
            [href]="match.links"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center mt-3 text-xs font-poppins font-semibold underline text-blue-600"
          >
            View Evidence
          </a>
        </li>
      </ul>
    </div>

    <div
      *ngIf="sortedMatches.length === 0"
      class="p-4 rounded-lg border border-green-200 bg-green-50 text-green-700 font-poppins"
    >
      No adverse blacklisting records were returned by any data sources.
    </div>
  </div>
</div>
